<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-large-plus"
    title="イントラネットFW プラットフォームゲートウェイ WVS2/KCPS アドレス設定"
  >
    <template v-slot:body="{ cancel }" v-if="isLoaded">
      <cross-validation-observer
        v-slot="{ handleSubmit }"
        :initial-values="{
          wvs2AddressList: wvs2AddressList,
          kcpsAddressList: kcpsAddressList,
        }"
        as="div"
      >
        <v-form novalidate @submit.stop.prevent="handleSubmit(submit)">
          <v-card-text class="px-0">
            <div class="modal-body">
              <v-container>
                <v-row>
                  <v-col cols="6">
                    <v-card variant="text" class="rounded-0">
                      <v-card-title class="screen-title card-title"
                        >WVS2ゾーン
                      </v-card-title>
                      <v-card-text class="pt-4">
                        <app-badge
                          item="WVS2アドレス"
                          :msg="
                            $filter.message(
                              'info_cidr_ip_address_of_network_address',
                              {
                                ipaddress1: '192.168.0.0/24',
                                genre: 'WVS2アドレス',
                                subnet1: '1',
                                subnet2: '30',
                                ipaddress2: '192.168.0.1/32',
                              }
                            )
                          "
                          placement="top"
                          :is-info="changeable"
                          :is-required="
                            changeable && wvs2AddressList.length > 1
                          "
                        />
                        <validation-array
                          name="wvs2AddressList"
                          v-slot="{ fields, push, remove }"
                        >
                          <template
                            v-for="(item, index) in fields"
                            :key="item.key"
                          >
                            <v-row class="ga-2 mt-2 mx-1">
                              <validation-provider
                                :name="`wvs2_${item.key}`"
                                v-model="wvs2AddressList[index]"
                                label="アドレス"
                                :rules="{
                                  required: wvs2AddressList.length > 1,
                                  is_ip_subnet: {
                                    min: 1,
                                    max: 32,
                                    exclude: [31],
                                  },
                                  is_not_current_ip: true,
                                  is_not_loopback_ip: true,
                                  is_not_multicast_ip: true,
                                  is_not_class_e_ip: true,
                                  is_not_broadcast_ip: true,
                                  is_network_address: true,
                                  duplicate: { list: existswvs2Address(index) },
                                }"
                                v-slot="{ componentField, errorMessage, meta }"
                              >
                                <app-form-input
                                  :placeholder="
                                    !changeable
                                      ? null
                                      : $filter.message(
                                          'placeholder_ip_address_of_private_network_address'
                                        )
                                  "
                                  v-bind="componentField"
                                  :error-messages="errorMessage"
                                  :field-meta="meta"
                                  :disabled="!changeable"
                                />
                              </validation-provider>
                              <v-btn
                                icon="$mdiMinus"
                                class="rounded-sm"
                                v-permission.config
                                size="small"
                                variant="outlined"
                                @click="removeWvs2(index, remove)"
                              />
                            </v-row>
                          </template>
                          <v-row justify="end" class="mt-2 mx-1">
                            <v-btn
                              v-permission.config
                              icon="$mdiPlus"
                              size="small"
                              variant="outlined"
                              class="rounded-sm"
                              @click="addWvs2(push)"
                            />
                          </v-row>
                        </validation-array>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col cols="6">
                    <v-card variant="text" class="rounded-0">
                      <v-card-title class="screen-title card-title"
                        >KCPSゾーン
                      </v-card-title>
                      <v-card-text class="pt-4">
                        <app-badge
                          item="KCPSアドレス"
                          :msg="
                            $filter.message(
                              'info_cidr_ip_address_of_network_address',
                              {
                                ipaddress1: '192.168.0.0/24',
                                genre: 'KCPSアドレス',
                                subnet1: '1',
                                subnet2: '30',
                                ipaddress2: '192.168.0.1/32',
                              }
                            )
                          "
                          placement="top"
                          :is-info="changeable"
                          :is-required="
                            changeable && kcpsAddressList.length > 1
                          "
                        />
                        <validation-array
                          name="kcpsAddressList"
                          v-slot="{ fields, push, remove }"
                        >
                          <template
                            v-for="(item, index) in fields"
                            :key="item.key"
                          >
                            <v-row class="ga-2 mt-2 mx-1">
                              <validation-provider
                                :name="`kcps_${item.key}`"
                                v-model="kcpsAddressList[index]"
                                label="アドレス"
                                :rules="{
                                  required: kcpsAddressList.length > 1,
                                  is_ip_subnet: {
                                    min: 1,
                                    max: 32,
                                    exclude: [31],
                                  },
                                  is_not_current_ip: true,
                                  is_not_loopback_ip: true,
                                  is_not_multicast_ip: true,
                                  is_not_class_e_ip: true,
                                  is_not_broadcast_ip: true,
                                  is_network_address: true,
                                  duplicate: { list: existskcpsAddress(index) },
                                }"
                                v-slot="{ componentField, errorMessage, meta }"
                              >
                                <app-form-input
                                  :placeholder="
                                    !changeable
                                      ? null
                                      : $filter.message(
                                          'placeholder_ip_address_of_private_network_address'
                                        )
                                  "
                                  v-bind="componentField"
                                  :error-messages="errorMessage"
                                  :field-meta="meta"
                                  :disabled="!changeable"
                                />
                              </validation-provider>
                              <v-btn
                                v-permission.config
                                icon="$mdiMinus"
                                class="rounded-sm"
                                size="small"
                                variant="outlined"
                                @click="removeKcps(index, remove)"
                              />
                            </v-row>
                          </template>
                          <v-row justify="end" class="mt-2 mx-1">
                            <v-btn
                              v-permission.config
                              icon="$mdiPlus"
                              size="small"
                              variant="outlined"
                              class="rounded-sm"
                              @click="addKcps(push)"
                            />
                          </v-row>
                        </validation-array>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
            </div>
            <cross-validation-provider
              :passed="isChanged"
              vid="changed"
              class="mt-4"
              >{{
                $filter.message("no_change_data")
              }}</cross-validation-provider
            >
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-list-item class="w-100 pa-1">
              <template v-slot:append>
                <v-btn
                  type="submit"
                  variant="flat"
                  color="primary"
                  v-permission.config
                  >設定
                </v-btn>
                <v-btn variant="outlined" color="primary" @click="cancel"
                  >キャンセル
                </v-btn>
              </template>
            </v-list-item>
          </v-card-actions>
        </v-form>
      </cross-validation-observer>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import type { PfgwZone, PfgwZonePut } from "@/apis/PfgwZoneApi";
import { VueFinalModal } from "vue-final-modal";
import AppFormInput from "@/components/AppFormInput.vue";

export default defineComponent({
  name: "IntranetFwPfgwZoneAddressEdit",
  components: { AppFormInput },
  props: {
    enumberAct: {
      type: String as PropType<string>,
      required: true,
    },
  },
  data() {
    return {
      pfgwZone: {} as PfgwZone,
      wvs2AddressList: [] as string[],
      kcpsAddressList: [] as string[],
      addressListBk: [] as string[],
      /** 初期通信完了フラグ */
      isLoaded: false,
    };
  },
  async mounted() {
    await this.load();
    this.isLoaded = true;
  },
  computed: {
    /** true: 変更可能, false: 変更不可 */
    changeable(): boolean {
      return this.$service.permission.hasAuthority("CONFIG");
    },
    /** 既存のKCPSアドレス */
    existskcpsAddress() {
      // 既存のアドレスリストに同じアドレスが存在した場合はエラーとする
      return (index: number) => {
        return [
          ...this.kcpsAddressList.filter((_, num) => num !== index),
          ...this.wvs2AddressList,
        ];
      };
    },
    /** 既存のWVS2アドレス */
    existswvs2Address() {
      // 既存のアドレスリストに同じアドレスが存在した場合はエラーとする
      return (index: number) => {
        return [
          ...this.wvs2AddressList.filter((_, num) => num !== index),
          ...this.kcpsAddressList,
        ];
      };
    },

    /**
     * 初期表示時と内容が変わっているかチェック
     * true: 変更あり
     * false: 変更無し
     */
    isChanged(): boolean {
      return this.$crossValidation.objectChanged(this.addressListBk, [
        ...this.wvs2AddressList,
        ...this.kcpsAddressList,
      ]);
    },
  },
  methods: {
    /** データ取得 */
    async load() {
      this.pfgwZone = await this.$api.pfgwZoneRelation.getPfgwZone(
        this.enumberAct
      );
      this.wvs2AddressList = this.pfgwZone.wvs2AddressList
        .map((e) => e.ipAddress)
        .sortIpAddress();

      this.kcpsAddressList = this.pfgwZone.kcpsAddressList
        .map((e) => e.ipAddress)
        .sortIpAddress();
      // アドレスリストは0件の場合、初期化
      if (this.wvs2AddressList.length === 0 && this.changeable) {
        this.wvs2AddressList = [""];
      }
      if (this.kcpsAddressList.length === 0 && this.changeable) {
        this.kcpsAddressList = [""];
      }
      // 更新前のデータを保持しておく(更新があるかチェックするため)
      this.addressListBk = [...this.wvs2AddressList, ...this.kcpsAddressList];
    },

    /** WVS2アドレス追加 */
    addWvs2(push: (item: any) => void) {
      const addItem = "";
      this.wvs2AddressList.push(addItem);
      // ValidationにFieldを追加することを伝える
      push(addItem);
    },

    /** WVS2アドレス削除 */
    removeWvs2(index: number, remove: (idx: number) => void) {
      if (this.wvs2AddressList.length > 1) {
        this.wvs2AddressList.splice(index, 1);
        // ValidationにFieldを削除することを伝える
        remove(index);
      } else {
        this.wvs2AddressList = [""];
      }
    },

    /** KCPSアドレス追加 */
    addKcps(push: (item: any) => void) {
      const addItem = "";
      this.kcpsAddressList.push(addItem);
      // ValidationにFieldを追加することを伝える
      push(addItem);
    },

    /** KCPSアドレス削除 */
    removeKcps(index: number, remove: (idx: number) => void) {
      if (this.kcpsAddressList.length > 1) {
        this.kcpsAddressList.splice(index, 1);
        // ValidationにFieldを削除することを伝える
        remove(index);
      } else {
        this.kcpsAddressList = [""];
      }
    },

    /** アドレス設定 */
    async submit() {
      await this.$confirm(`アドレスを設定します。よろしいですか？`);

      // 更新データの設定 アドレス入力無しの場合は空配列を設定する
      const reqData: PfgwZonePut = {
        wvs2AddressList:
          this.wvs2AddressList.length === 1 && !this.wvs2AddressList[0]
            ? []
            : this.wvs2AddressList,
        kcpsAddressList:
          this.kcpsAddressList.length === 1 && !this.kcpsAddressList[0]
            ? []
            : this.kcpsAddressList,
        zoneIdList: this.pfgwZone.zoneIdList,
        pfgwAddressKeyId: this.pfgwZone.pfgwAddressKeyId,
      };

      await this.$api.pfgwZoneRelation.putPfgwZone(this.enumberAct, reqData);
      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
    },
  },
});
</script>
<style lang="scss" scoped>
.modal-body {
  min-height: 55vh;
}
</style>
